import { Component } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-loading-file-clients',
  templateUrl: './modal-loading-file-clients.component.html',
  styleUrls: ['./modal-loading-file-clients.component.scss']
})
export class ModalLoadingFileClientsComponent {

  ngOnInit(): void {
    /*Swal.fire({
      title: 'Cargando Informacion',
      //timer: 5000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
      },
    });*/
  }

  ngOnDestroy(): void{
    //Swal.close();
  }

}
